const fighters = [
  // Marvel
  "Spider-Man", "Iron Man", "Thor", "Hulk", "Wolverine",
  "Doctor Strange", "Black Panther", "Captain America", "Deadpool", "Thanos",
  // DC
  "Batman", "Superman", "Wonder Woman", "The Flash", "Aquaman",
  "Green Lantern", "Darkseid", "Joker", "Shazam", "Cyborg",
  // Anime
  "Goku", "Naruto", "Saitama", "Luffy", "Vegeta",
  "Itachi", "Gojo", "Levi Ackerman", "Tanjiro", "All Might",
  // Gaming
  "Kratos", "Master Chief", "Link", "Mario", "Geralt of Rivia",
  "Dante", "Solid Snake", "Sephiroth", "Doomguy", "Kirby",
  // Mythology
  "Zeus", "Odin", "Hercules", "Anubis", "Medusa",
  "Sun Wukong", "Athena", "Poseidon", "Loki", "Ares",
  // Movies / TV
  "John Wick", "Darth Vader", "Gandalf", "Godzilla", "King Kong",
  "Optimus Prime", "Predator", "Terminator", "Neo", "Shrek",
];

const entities = [
  // Civilizations
  "The Roman Empire", "The Mongol Empire", "Ancient Egypt", "The Byzantine Empire",
  // Diseases / biology
  "The Black Death", "Covid-19", "Ebola", "The Spanish Flu",
  // Forces of nature
  "A Category 5 Hurricane", "Mount Vesuvius", "A Massive Tsunami", "A Supervolcano Eruption",
  // Astronomical
  "A Black Hole", "The Sun", "A Neutron Star", "A Gamma-Ray Burst",
  // Companies / orgs
  "Apple", "Google", "Amazon", "The United States Military",
  // Abstract concepts
  "Time", "Entropy", "Chaos", "Death",
  // Armies / hordes
  "A Zombie Apocalypse", "A Locust Swarm", "The Spartan 300", "A Nuclear Arsenal",
  // Events / eras
  "World War 2", "The Ice Age", "A Mass Extinction Event",
];

// Pool of curated cross-type matchups for "Surprise Me"
const specialMatchups = [
  ["The Roman Empire", "The Black Death"],
  ["A Black Hole", "Superman"],
  ["Apple", "Google"],
  ["A Zombie Apocalypse", "The Spartan 300"],
  ["Goku", "A Neutron Star"],
  ["The Mongol Empire", "A Supervolcano Eruption"],
  ["Batman", "Covid-19"],
  ["Time", "The Roman Empire"],
  ["Death", "Deadpool"],
  ["A Category 5 Hurricane", "The United States Military"],
  ["Amazon", "The Byzantine Empire"],
  ["Thanos", "Entropy"],
];

const characters = [...fighters, ...entities];

export function getRandomPair() {
  // 30% chance to surface a curated cross-type matchup
  if (Math.random() < 0.3) {
    return specialMatchups[Math.floor(Math.random() * specialMatchups.length)];
  }
  const shuffled = [...characters].sort(() => Math.random() - 0.5);
  return [shuffled[0], shuffled[1]];
}

export function getSuggestedMatchups(count = 3) {
  const matchups = [];
  const used = new Set();
  while (matchups.length < count) {
    const [a, b] = getRandomPair();
    const key = [a, b].sort().join(":");
    if (!used.has(key)) {
      used.add(key);
      matchups.push([a, b]);
    }
  }
  return matchups;
}

export default characters;
